import { createTheme } from '@mui/material/styles';

// Brand colors match the React Native app (r2b-restaurant-mobile-new):
//   Primary: #851E41 (maroon)
//   Success/Accept: #10B981
//   Danger/Reject: #EF4444
// Font family is Poppins (loaded in index.html from Google Fonts).
const theme = createTheme({
  palette: {
    primary: {
      main: '#851E41',
      dark: '#671532',
      light: '#A23C5F',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#10B981',
      contrastText: '#ffffff',
    },
    error: {
      main: '#EF4444',
    },
    success: {
      main: '#10B981',
    },
    warning: {
      main: '#F59E0B',
    },
    info: {
      main: '#3B82F6',
    },
    background: {
      default: '#F8FAFC',
      paper: '#ffffff',
    },
    text: {
      primary: '#1F2937',
      secondary: '#6B7280',
    },
  },
  typography: {
    fontFamily: '"Poppins", "Helvetica", "Arial", sans-serif',
    h1: { fontFamily: '"Poppins", sans-serif', fontWeight: 700 },
    h2: { fontFamily: '"Poppins", sans-serif', fontWeight: 700 },
    h3: { fontFamily: '"Poppins", sans-serif', fontWeight: 700 },
    h4: { fontFamily: '"Poppins", sans-serif', fontWeight: 600 },
    h5: { fontFamily: '"Poppins", sans-serif', fontWeight: 600 },
    h6: { fontFamily: '"Poppins", sans-serif', fontWeight: 600 },
    body1: { fontFamily: '"Poppins", sans-serif', fontWeight: 400 },
    body2: { fontFamily: '"Poppins", sans-serif', fontWeight: 400 },
    button: { fontFamily: '"Poppins", sans-serif', fontWeight: 600, textTransform: 'none' },
    subtitle1: { fontFamily: '"Poppins", sans-serif', fontWeight: 500 },
    subtitle2: { fontFamily: '"Poppins", sans-serif', fontWeight: 500 },
    caption: { fontFamily: '"Poppins", sans-serif', fontWeight: 400 },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          paddingTop: 10,
          paddingBottom: 10,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#851E41',
        },
      },
    },
  },
});

export default theme;
